import type { BrowserEnvConfig } from "./browser-env";
import type { Environments, Urls } from "./types";

export type { Environments, Urls } from "./types";

export type BrowserCredentials = {
	mapboxToken: string;
	googleApiKey: string;
};

type BrowserServicesOrchestratorConfig = {
	env: BrowserEnvConfig;
};

/** Browser-only shared-service projection; this module has no server credential vocabulary. */
export class BrowserServicesOrchestrator {
	private readonly envConfig: BrowserEnvConfig;

	constructor(config: BrowserServicesOrchestratorConfig) {
		this.envConfig = config.env;
	}

	private getEnv<K extends keyof BrowserEnvConfig>(key: K): BrowserEnvConfig[K] {
		return this.envConfig[key];
	}

	get environment(): Environments {
		return this.getEnv("COMMON_ENV_ENVIRONMENT") as Environments;
	}

	get isProduction(): boolean {
		return this.environment === "production";
	}

	get isUat(): boolean {
		return this.environment === "uat";
	}

	get isDevelopment(): boolean {
		return this.environment === "develop";
	}

	get urls(): Urls {
		return {
			cdn: this.getEnv("COMMON_ENV_CDN_URL"),
			cms: this.getEnv("COMMON_ENV_CMS_URL"),
			platform: this.getEnv("COMMON_ENV_PLATFORM_URL"),
			webapp: this.getEnv("COMMON_ENV_WEBAPP_URL"),
			courier: this.getEnv("COMMON_ENV_COURIER_URL"),
			vision: this.getEnv("COMMON_ENV_VISION_AI_URL"),
			pricing: this.getEnv("COMMON_ENV_PRICING_URL"),
			grader: this.getEnv("COMMON_ENV_GRADER_URL"),
			urlShortener: this.getEnv("COMMON_ENV_URL_SHORTENER"),
		};
	}

	get credentials(): BrowserCredentials {
		return {
			mapboxToken: this.getEnv("COMMON_ENV_MAPBOX_TOKEN"),
			googleApiKey: this.getEnv("COMMON_ENV_GOOGLE_API_KEY"),
		};
	}
}
